import { FormValue } from '../reducers/form-values'

export const setFormValues = (instanceId: string, formId: string, values: FormValue[]) => ({
  type: 'SET_FORM_VALUES',
  instanceId,
  formId,
  values
})

export const setFormValue = (instanceId: string, formId: string, id: string, value: FormValue) => ({
  type: 'SET_FORM_VALUE',
  instanceId,
  formId,
  id,
  value
})
